<template>
  <div class="editor-container relative h-auto p-4 bg-gray-50">
    <form @submit.prevent="compileNotes" class="space-y-6">
      <div class="text-sm pb-4">
        <!-- Added padding-bottom (pb-4) -->
        <label class="block pb-1 font-bold">Handover Notes</label>
        <RichTextEditor :info="notes" @content-changed="handleContentChanged" />

        <!-- Flex container for button alignment -->
        <div class="flex flex-col md:flex-row md:justify-end">
          <button
            type="submit"
            class="bg-yellow-500 hover:bg-yellow-600 text-white rounded-full px-4 mt-2 shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 w-full md:w-auto"
          >
            Submit
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import RichTextEditor from '@/components/editor/RichTextEditor.vue';

export default {
  name: 'CustomEditor',
  props: ['handleSubmit', 'handleContentChangedLocal', 'notes'],
  components: { RichTextEditor },
  data() {
    return {};
  },
  methods: {
    handleContentChanged(newContent) {
      this.handleContentChangedLocal(newContent);
    },

    compileNotes() {
      this.handleSubmit();
    },
  },
};
</script>

<style scoped>
.editor-container {
  max-width: 800px;
  margin: auto;
  padding: 1rem;
}
</style>
